import { EqxLoading, useButtonLoading } from '@equinoxx/react'
import React from 'react'
import { Button, ButtonGroup } from 'react-bootstrap'
import './EqxButton.css'
const EqxButton = function (props: {
    children?: React.ReactNode
    size?: 'sm' | 'lg'
    type?: 'create' | 'add' | 'edit' | 'delete' | 'save' | 'cancel'
    text?: string | React.ReactNode
    icon?: string
    colourType?: string
    variant?: string
    href?: string
    download?: string
    tooltip?: string
    disabled?: boolean
    id?: string
    onClick?: (e: React.MouseEvent<Element, MouseEvent>) => any
}) {
    const { loading, onClick } = useButtonLoading(props.onClick)
    let { children, type, icon, text, colourType, ...buttonProps } = props
    if (type) {
        let colour = null
        switch (type) {
            case 'create':
            case 'add':
                colour = 'success'
                icon = icon ?? 'fas fa-plus'
                text = text ?? 'Add'
                break
            case 'edit':
                colour = 'warning'
                icon = icon ?? 'fas fa-pencil'
                text = text ?? 'Edit'
                break
            case 'delete':
                colour = 'danger'
                icon = icon ?? 'fas fa-trash'
                text = text ?? 'Delete'
                break
            case 'save':
                colour = 'success'
                icon = icon ?? 'fas fa-save'
                text = text ?? 'Save'
                break
            case 'cancel':
                colour = 'secondary'
                colourType = 'outline'
                icon = icon ?? 'fas fa-times'
                text = text ?? 'Cancel'
                break
        }
        if (colour) buttonProps.variant = buttonProps.variant ?? (colourType != 'outline' ? '' : 'outline-') + colour
    }
    const disabled = props.disabled || loading
    return (
        <Button {...buttonProps} disabled={disabled} onClick={onClick}>
            {loading ? (
                <EqxLoading size="sm" />
            ) : (
                children ?? (
                    <>
                        {icon && <span className={icon}></span>}{' '}
                        {text && <span className={icon ? "d-none d-sm-inline" : ""}>{text}</span>}
                    </>
                )
            )}
        </Button>
    )
}
const EqxButtonGroup = (props: { children: React.ReactNode; separate?: boolean }) => {
    if (props.separate) {
        return <div className="eqx-btn-group-separate">{props.children}</div>
    }
    return <ButtonGroup>{props.children}</ButtonGroup>
}
export { EqxButton as default, EqxButtonGroup }

